import { inject, Injectable } from '@angular/core';
import { MultiOrderImportResult, OrderImportService } from 'gung-standard';
import { Observable } from 'rxjs';
import { HlDisplayMsflowArgumentService } from './hl-display-msflow-argument.service';
import { HlDisplayPortalFeaturesService } from './hl-display-portal-features.service';

@Injectable({
  providedIn: 'root'
})
export class HlDisplayOrderImportService extends OrderImportService {
  private featuresService = inject(HlDisplayPortalFeaturesService);

  public parseMultiOrderColumnExcel(formData: FormData): Observable<MultiOrderImportResult> {
    const portalName = this.featuresService.getPortalName();
    const url = `json/hl-display/order-xlsx-import/multi-order/${portalName}`;
    return this.http.post<MultiOrderImportResult>(url, formData);
  }

  public downloadMultiOrderTemplate(): Observable<Blob> {
    const portalName = this.featuresService.getPortalName();
    const url = `json/hl-display/order-xlsx-import/multi-order/template/${portalName}`;
    return this.http.get(url, { responseType: 'blob' });
  }

}
